import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/common/Navbar';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useAuth } from './hooks/useAuth';

// Lazy load pages for code splitting
const Login = lazy(() => import('./pages/Login'));
const Map = lazy(() => import('./pages/Map'));
const CityDetail = lazy(() => import('./pages/CityDetail'));
const Stats = lazy(() => import('./pages/Stats'));
const Poster = lazy(() => import('./pages/Poster'));
const Import = lazy(() => import('./pages/Import'));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-neon-cyan/30 border-t-neon-cyan rounded-full animate-spin mx-auto mb-4" />
      <p className="text-gray-400">加载中...</p>
    </div>
  </div>
);

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-dark-bg">
        {isAuthenticated && <Navbar />}
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route
                path="/login"
                element={isAuthenticated ? <Navigate to="/map" /> : <Login />}
              />
              <Route
                path="/map"
                element={isAuthenticated ? <Map /> : <Navigate to="/login" />}
              />
              <Route
                path="/city/:id"
                element={isAuthenticated ? <CityDetail /> : <Navigate to="/login" />}
              />
              <Route
                path="/stats"
                element={isAuthenticated ? <Stats /> : <Navigate to="/login" />}
              />
              <Route
                path="/poster"
                element={isAuthenticated ? <Poster /> : <Navigate to="/login" />}
              />
              <Route
                path="/import"
                element={isAuthenticated ? <Import /> : <Navigate to="/login" />}
              />
              <Route path="/" element={<Navigate to="/map" />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </div>
    </BrowserRouter>
  );
}

export default App;
